import { jsx as $ } from "react/jsx-runtime";
import { u as o } from "./styled-components.browser.esm-3eb04950.js";
import { useLanguageResolver as d } from "@biron-data/react-contexts";
const u = ({
  size: i = 19,
  margin: t = 0,
  containerSize: r,
  clickable: n = !1,
  color: l,
  hoverColor: c,
  onClick: h,
  children: s,
  disable: a,
  titleKey: e
}) => {
  const x = d();
  return /* @__PURE__ */ $(g, { onClick: h, $containersize: r, title: e ? x.get(e) : void 0, children: /* @__PURE__ */ $(m, { $margin: t, $size: i, $color: l, $clickable: n ? 1 : 0, $disable: a, $hovercolor: c, children: s }) });
}, m = o.div`
  display: flex;
  max-width: fit-content;
    width: ${(i) => `${i.$size}px`};
    min-width: ${(i) => `${i.$size}px`};
    height: ${(i) => `${i.$size}px`};
    min-height: ${(i) => `${i.$size}px`};
    margin-right: ${(i) => i.$margin}px;
    line-height: ${(i) => `${i.$size}px`};

    ${(i) => i.$color ? `color: ${i.$color};` : ""}
  
  &&& svg {
        width: ${(i) => `${i.$size}px`};
        min-width: ${(i) => `${i.$size}px`};
        height: ${(i) => `${i.$size}px`};
        min-height: ${(i) => `${i.$size}px`};
  }

    ${(i) => i.$clickable ? `
      cursor: pointer;
      
      &:hover {
         color: ${i.$hovercolor ? `${i.$hovercolor}` : "var(--primary)"};
      }
      ` : ""}

    ${({ $disable: i }) => i ? "cursor: not-allowed;" : ""}
`, g = o.div`
  &&& {
    height: 100%;
    ${({ $containersize: i }) => i ? `width: ${i}px;height: ${i}px;` : ""}
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
export {
  u as IconContainer
};
//# sourceMappingURL=IconContainer.js.map
